// Autogenerated file
export const messengerTypesEnum = {
    WhatsApp: "WhatsApp",
    Telegram: "Telegram",
    Max: "Max",
};
export const messengerTypes = [
    { label: "WhatsApp", value: "WhatsApp" },
    { label: "Telegram", value: "Telegram" },
    { label: "MAX", value: "Max" },
];
